import { Record, List } from "immutable";
import TemplateGenerator from "../../../staff/utils/templateGenerator";

const defaultRecord = {
  // параметры информера
  name: "",
  id: undefined,
  campaign: undefined,
  srcjs: "",
  rows: 3,
  cols: 1,
  width: 100,
  width_unit: "%",
  charset: "utf8",
  border_width: 0,
  border_color: "#fff",

  // параметры тизера
  img_size: "100_100",
  img_align: "left",
  img_margin: 5,
  img_border_width: 0,
  img_border_color: "#fff",

  text_align: "left",
  teaser_background_color: "#fff",
  teaser_border_width: 0,
  teaser_border_color: "#fff",
  teaser_margin: 3,
  teaser_padding: 10,

  // параметры содержимого информера
  title_font_family: "inherit",
  title_font_size: 13,
  title_font_color: "#000",
  title_font_color_hover: "#000",
  list_style: "none",

  // стиль заголовка
  title_bold: false,
  title_italic: false,
  title_underline: false,

  // стиль заголовка при наведении
  title_bold_hover: false,
  title_italic_hover: false,
  title_underline_hover: false,

  category_visible: false,
  category_font_size: 11,
  category_font_color: "#000",

  categories: new List([]),

  css: "",
  tpl: ""
};

const generator = new TemplateGenerator(defaultRecord);

defaultRecord.css = generator.getCssTempl();
defaultRecord.tpl = generator.getInformerTempl();

const InformerRecord = new Record(defaultRecord);

export default class Informer extends InformerRecord {}
